import React from 'react';
import {connect} from 'react-redux';
import Modal from 'react-responsive-modal';
import 'react-responsive-modal/lib/react-responsive-modal.css';

import LanguageStringResolver from '../fields/language/LanguageStringResolver';
import UploadPanel from '../upload/UploadPanel';

import Logger, { LOG_LEVELS } from '../../utils/logger';
const log = new Logger('UPLOAD_PAGE', LOG_LEVELS.DEBUG);
const MAX_FILE_SIZE_IN_MB = 3;

const MODAL_CLASSNAMES =  {
    modal: 'modal-full-width-height modal-max-width-65'
};

class AttachmentUploadModal extends React.Component {

    constructor(props) {
        super(props);
        this.state = { attachmentDescription: "" };
        this.attachmentDescriptionReset = false;
        this.onAttachmentDescriptionEntered = this.onAttachmentDescriptionEntered.bind(this);
    }

    onAttachmentDescriptionEntered(evt) {
        this.setState({ attachmentDescription: evt.target.value });
    }

    onUploadRequest(filesToBeSent) {
        log.debug('onUploadRequest(): ', filesToBeSent);
        if(filesToBeSent.length <= 0){
          alert("Please upload some files first");
          return;
        }
        let attachmentData = {
            attachmentFile: filesToBeSent[0],
            id: this.props.attachmentUpload.id,
            attachmentName: filesToBeSent[0].name,
            attachmentDescription: this.state.attachmentDescription === "" ? undefined : this.state.attachmentDescription
        };
        this.props.onSubmit(attachmentData);
    }
    
    render() {
        const transactionFileTypes = [".xlsx", ".xls", ".zip", ".txt"]; //removed ".pdf"; PDF issue in VR Rest API (see SVR-1088)
        if (this.attachmentDescriptionReset !== this.props.attachmentDescriptionReset) {
            this.setState({ attachmentDescription: "" });
        }
        this.attachmentDescriptionReset = this.props.attachmentDescriptionReset;
        return(
            <div>
                <Modal
                    classNames={MODAL_CLASSNAMES}
                    open={this.props.open}
                    onClose={this.props.onClose}
                    closeOnEsc={true}
                    blockScroll={true}
                    closeOnOverlayClick={false}
                    center
                    >
                    <h2><LanguageStringResolver string='transactionAttachment_title'/></h2>
                    <UploadPanel
                        uploadLimit={1}
                        acceptTypes={transactionFileTypes}
                        onUploadRequest={this.onUploadRequest.bind(this)}
                        maxSizeInKB={MAX_FILE_SIZE_IN_MB * 1000}
                    /> 
                    <s-box>
                        <h2><LanguageStringResolver string='uploadInformation'/></h2>
                        <label><LanguageStringResolver string='transactionAttachment_description'/></label>
                        <input 
                            type="text"
                            maxLength="250"
                            onChange={this.onAttachmentDescriptionEntered}
                            name="attachmentDescription"
                            className="mt10"
                            value={this.state.attachmentDescription}
                        />
                        <p className="accepted-file-types">
                            <LanguageStringResolver string='acceptedFormats'/>
                            <br /> 
                            {transactionFileTypes.map((fileType, index) => {
                                return (
                                    <span key={index} className="semi-bold">
                                        <LanguageStringResolver string={fileType}/>
                                    </span>
                                )
                            })}
                        </p>
                        <p>
                            <LanguageStringResolver string='transactionAttachment_maxFileSizeInMB'/>:
                            <br/>
                            <span>{`${MAX_FILE_SIZE_IN_MB} MB`}</span>
                        </p>
                        <p className="mb5"><LanguageStringResolver string='rightToUse'/></p>
                    </s-box>
                </Modal>
            </div>
        );
    }
}


AttachmentUploadModal.defaultProps = {
    onClose: () => {},
    attachmentUpload: {},
    onSubmit: () => {}
}

function mapStateToProps(state) {
    return {};
}

export default connect(mapStateToProps)(AttachmentUploadModal);
